import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class PaymentOrdersDailyInternationalTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      payment_date: '',
      id: this.props.payment_order_id,
      payment_order_payments_daily_international: [],
      days: [],
      modal: false,
    };
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.openDaysModal = this.openDaysModal.bind(this);
    this.deletePaymentOrderPayment = this.deletePaymentOrderPayment.bind(this);
    this.creditLabel = this.creditLabel.bind(this);
    this.export = this.export.bind(this);

    this.locale = getLocale();
  }


  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.id === 'undefined' && typeof newProps.payment_order_id !== 'undefined') {
      this.setState({
        id: newProps.payment_order_id,
      });
    }
    if(Array.isArray(newProps.payment_order_payments_daily_international)) {
      this.setState({payment_order_payments_daily_international: newProps.payment_order_payments_daily_international});
    }
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        {
          (this.props.payment_order_data.status === 'aberto') ?
            <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletePaymentOrderPayment}>
              <i className="fa fa-fw fa-trash"></i>
            </button>
            :
            <button className="btn btn-sm btn-danger" value={cell} disabled>
              <i className="fa fa-fw fa-trash"></i>
            </button>
        }
        <button className="btn btn-sm btn-success" value={cell} onClick={this.openDaysModal}>
          <i className="fa fa-fw fa-calendar"></i>
        </button>
      </div>
    );

    return botao;
  }

  creditLabel (cell, row) {
    var botao = '';
    if (row.debt === 1 && row.credit === 1) {
      var botao = (
        <div className="btn-group">
          <p><i className="text-success fa fa-fw fa-warning"></i><i className="text-danger fa fa-fw fa-warning"></i></p>
        </div>
      );
    } else if(row.debt === 1) {
      var botao = (
        <div className="btn-group">
          <p className="text-danger"><i className="fa fa-fw fa-warning"></i></p>
        </div>
      );
    } else if(row.credit === 1) {
      var botao = (
        <div className="btn-group">
          <p className="text-success"><i className="fa fa-fw fa-warning"></i></p>
        </div>
      );
    }

    return botao;
  }
  
  deletePaymentOrderPayment (event) {
    var payment_order_payment_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.deletar);
    if (confirm) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/ordem/pagamento/deletar/pagamento/' + payment_order_payment_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshInternationals(responseJson);
          } else if (responseJson.status === 'warning') {
            if(window.confirm(responseJson.message)) {
              Promise.resolve(header).then(function(value) {
                fetch(config.get('api') + '/ordem/pagamento/confirmar/deletar/pagamento/' + payment_order_payment_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
                  self.refs.request_api.validate(responseJson, 'alert');
                  if (responseJson.status === 'success') {
                    self.props.refreshTransport(responseJson);
                  } else {
                    self.props.handleAlert(responseJson.message, responseJson.status, 'open');
                  }
                }).catch((error) => {
                  console.error(error);
                });
              });
            }
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  openDaysModal (event) {
    var payment_order_payment_id = event.currentTarget.value;
    var self = this;
    self.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ordem/pagamento/status/dias/' + payment_order_payment_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.handleAlert('', '', 'closed');
          self.setState({days: responseJson.data, modal: true});
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  export(event) {
    var url = event.currentTarget.value;
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <hr/>
  <button className="btn btn-success btn-block" value={'/exportar/ordem-de-pagamento/internacionais/'+this.state.id} onClick={this.export}>
    <i className="fa fa-fw fa-table"></i> {this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.botaoExportarDiariasInternacionais}
  </button>
  <hr/>
  <BootstrapTable data={this.state.payment_order_payments_daily_international} pagination={true} striped={true} hover={true} options={{noDataText: this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.semPagamentosEmAberto}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.Acoes}</TableHeaderColumn>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="credit" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60' dataFormat={this.creditLabel}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.Saldo}</TableHeaderColumn>
    <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.Nome}</TableHeaderColumn>
    <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.Periodo}</TableHeaderColumn>
    <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.Treinamento}</TableHeaderColumn>
    <TableHeaderColumn dataField="training_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.NumeroERev}</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_paid" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.Diarias}</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.ValorDiaria}</TableHeaderColumn>
    <TableHeaderColumn dataField="debt_charge" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.Desconto}</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.TotalEmDiarias}</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_currency" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabela.Moeda}</TableHeaderColumn>
  </BootstrapTable>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tituloDiasDoPagamento}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabelaDiasDoPagamento.Data}</th>
              <th>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabelaDiasDoPagamento.Diarias}</th>
              <th>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tabelaDiasDoPagamento.Status}</th>
            </tr>
          </thead>
          <tbody>
          {Object.keys(self.state.days).map(function(k) {
            var day = self.state.days[k];
            return (
              <tr>
                <td>{day.date_str}</td>
                <td>{day.coefficient}</td>
                <td>
                  {day.active === 0 ?
                    <span className="label label-danger">{day.status_str}</span> : <span className="label label-success">{day.status_str}</span>
                  }

                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default PaymentOrdersDailyInternationalTab;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/Elements/PaymentOrdersDailyInternationalTab.js